import type { ComponentProps } from 'react';

import { Slot } from '@radix-ui/react-slot';
import { cn } from '@repo/lib/cn';
import { ChevronRight } from 'lucide-react';

export function Breadcrumb(BreadcrumbProps: ComponentProps<'nav'>) {
  return <nav aria-label="breadcrumb" data-slot="breadcrumb" {...BreadcrumbProps} />;
}

export function BreadcrumbList(BreadcrumbListProps: ComponentProps<'ol'>) {
  const { className, ...props } = BreadcrumbListProps;
  return <ol data-slot="breadcrumb-list" className={cn('flex items-center gap-0.5 text-sm whitespace-nowrap', className)} {...props} />;
}

export function BreadcrumbItem(BreadcrumbItemProps: ComponentProps<'li'>) {
  const { className, ...props } = BreadcrumbItemProps;
  return (
    <li
      data-slot="breadcrumb-item"
      className={cn(
        'hover:bg-muted/50 dark:hover:card text-muted-foreground hover:text-accent-foreground inline-flex shrink-0 cursor-pointer items-center gap-1 rounded-md px-2 py-1 transition-all duration-150',
        className
      )}
      {...props}
    />
  );
}

export function BreadcrumbLink(
  BreadcrumbLinkProps: ComponentProps<'a'> & {
    asChild?: boolean;
  }
) {
  const { className, asChild, ...props } = BreadcrumbLinkProps;
  const Comp = asChild ? Slot : 'a';

  return <Comp data-slot="breadcrumb-link" className={cn('flex h-full w-full items-center justify-center', className)} {...props} />;
}

export function BreadcrumbPage(BreadcrumbPageProps: ComponentProps<'span'>) {
  const { className, ...props } = BreadcrumbPageProps;
  return <span data-slot="breadcrumb-page" role="link" aria-disabled="true" aria-current="page" className={cn('text-foreground h-full', className)} {...props} />;
}

export function BreadcrumbSeparator(BreadcrumbSeparatorProps: ComponentProps<'li'>) {
  const { className, children, ...props } = BreadcrumbSeparatorProps;
  return (
    <li data-slot="breadcrumb-separator" role="presentation" aria-hidden="true" className={cn('[&>svg]:size-3.5', className)} {...props}>
      {children ?? <ChevronRight />}
    </li>
  );
}
